import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { useRemoveWorkspaceAccessModal } from "./hooks";

type RemoveWorkspaceAccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  workspaceName: string;
  userName: string;
  arenaId: string;
  userId: string;
};

export const RemoveWorkspaceAccessModal = ({
  isOpen,
  onClose,
  workspaceName,
  userName,
  arenaId,
  userId,
}: RemoveWorkspaceAccessModalProps) => {
  const { removeWorkspaceAccess, loading } = useRemoveWorkspaceAccessModal({ onClose });

  const handleConfirm = async () => {
    await removeWorkspaceAccess({
      arenaIds: [arenaId],
      userIds: [userId],
    });
  };

  return (
    <ModalV2
      data-testid="remove-workspace-access-modal"
      title="Remove workspace access"
      description={workspaceName}
      show={isOpen}
      onHide={onClose}
      size="small"
    >
      <ModalV2.Body>
        <Text variant="regular-lg" marginBottom="md">
          Are you sure you want to remove access to the {workspaceName} workspace for {userName}
          ?
        </Text>
        <Text variant="regular-lg" marginBottom="xl">
          Any active work assigned to {userName} will be need to be unassigned.
        </Text>

        <Flex gap={SPACING.MEDIUM} justifyContent="end">
          <Button variant="neutral" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            isLoading={loading}
            disabled={loading}
          >
            Remove workspace access
          </Button>
        </Flex>
      </ModalV2.Body>
    </ModalV2>
  );
};
